<template>
  <div class="container">
    <div class="left" style="background:#f0f2f6;">
      <div class="Side">
        <center>
          <img style="width: 80%;height: auto;" src="../img/logo.png" />
        </center>
        <label>
          <h3>Project Introduction</h3>
        </label>
        <hr>
        <label>
          <h5>Welcome to AICelltype</h5>
        </label>
        <label style="font-size: 0.9rem; line-height: 180%;">
          <strong>AICelltype</strong> is an intelligent cell type annotation tool powered by the cutting-edge large language model, <strong> Claude 3.5 Sonnet</strong>. After a comprehensive benchmark of 79 leading models, we selected the top performer to bring you:
        </label>
        <ul style="font-size: 0.9rem;margin: 0,0,0,0; line-height: 180%;">
          <li><strong>Accurate &amp; Efficient</strong>: Achieves up to 70% exact match rate, significantly outperforming traditional methods.</li>
          <li><strong>Free &amp; User‑Friendly</strong>: Offers a convenient online annotation platform and an R package for seamless integration with standard workflows like Seurat.</li>
          <li><strong>Robust &amp; Powerful</strong>: Demonstrates excellent performance in rare cell identification, cross‑dataset generalization, and supports both single‑cell and spatial transcriptomics data.AICelltype aims to simplify your research and empower new breakthroughs in single‑cell studies.<strong>Start your cell annotation journey now!</strong></li>
        </ul>
        <hr/>
        <label>
          We welcome feedback and suggestions. Please feel free to report issues or request features via our GitHub issues page.<a href="https://github.com/mooerccx/AICelltype">GitHub repository</a>
        </label>
        <br/>
        <br/>
        <br/>
        </div>
      </div>
    <div class="right">
      <p style="text-align:center"><font color="#2087D6" size=6>AICelltype Online Cell Type Annotation Platform</font></p>
        <div class="child">
          <span style="font-size: small;">Please enter the name of the tissue from which the cells are derived:</span>
          <el-input v-model="tissue"  size="large" style="margin-top: 10pt;" clearable placeholder="PBMC" />
          <br/> 
          <br/>
          <span style="font-size: small;">Please enter the list of marker genes to be annotated, one cluster per line.</span>
          <el-input v-model="markergenes"  :rows="6" type="textarea"  :placeholder="example" />
          <br/>
          <br/>
          <span style="font-size: small;">You can also upload the top 10 gene list obtained from Seurat analysis.</span>
          <div class="upload">
            <el-upload
                ref   = "uploadRef"
                class = "upload-demo"
                drag
                :before-upload = "beforeupload"
                :on-success    = "onsuccess"
                :on-error      = "onerror"
                :on-remove     = "onremove"
                :on-change     = "onchange"
                :auto-upload   = false
                :limit         = "1"
                :action        = "uploadurl"
                :data          = "info"
                multiple
              >
              <el-icon class="el-icon--upload"><upload-filled /></el-icon>
              <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
              <template #tip>
                <div class="el-upload__tip">csv/tsv files with a size less than 500kb
                  <el-button type="primary" link @click="DownloadSample">Download sample file</el-button>
                </div>
              </template>
            </el-upload>
          </div>
        <el-button type="primary" :icon="Search" @click="Annotation">Annotation</el-button>
        <el-table :data="tableData" style="width: 100%" height="350pt" stripe border v-show="tabshow">
          <el-table-column prop="cluster"  label="cluster"  min-width="75" />
          <el-table-column prop="markers"  label="markers"  min-width="300" />
          <el-table-column prop="celltype" label="celltype" min-width="120" />
          <el-table-column prop="basis"    label="basis"    min-width="400" />
          <el-table-column fixed="right"   label="continue" min-width="90">
            <template #default="scope">
              <el-button
              link
              type="primary"
              size="small"
              @click.prevent="Connect_AI(scope.$index)"
              >
              Connect_AI
            </el-button>
            </template>
          </el-table-column>
        </el-table>    
        </div>
        <el-dialog 
          class         = "chat" 
          v-model       = "chatroom" 
          title         = "AICelltype" 
          width         = "600" 
          draggable     = "true"
          :modal        = "false"
          :before-close = "ChatBeforeClose"
          center>
          <div class="chat-message" ref="chatDIV">
            <div class="chat-msg.system">
              The cluster with marker gene <el-text class="mx-1" type="primary">{{ prompt.markers }}</el-text> in your <el-text class="mx-1" type="primary">{{ tissue }}</el-text> sample has been annotated as <el-text class="mx-1" type="primary">{{ prompt.celltype }}</el-text>. For more detailed annotation basis, please continue to enter the query
            </div>
            <hr/>
            <div v-for="itmes in msg" :class="['chat-msg', itmes.role]" :key=itmes.content>
                {{ itmes.content }}
            </div>
            <div v-loading="loading" v-show="Loading" class="chat-msg.system"></div>
          </div>
          <div class="chat-input">
            <el-input
              class       = "chat-input-msg"
              v-model     = "newMessage"
              placeholder = "Send a message……"
              maxlength   = "200"
              type        = "textarea"
              resize      = "none"
              clearable
              @keyup.enter="sendMessage"
              :autosize="{ minRows: 1, maxRows: 2 }"
            />
            <el-button
              class     = "chat-input-button"
              type      = "primary"
              :icon     = "Tickets"
              @click    = "sendMessage"
              :disabled = "!newMessage.trim()">Send</el-button>
          </div>
        </el-dialog>
      </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch, nextTick} from 'vue'
import axios from 'axios'
import { UploadFilled ,Search,Tickets, Loading} from '@element-plus/icons-vue'
import type { UploadProps, UploadUserFile, UploadInstance} from 'element-plus'
import {ElMessage, ElMessageBox, ElNotification} from 'element-plus'

/* -------------------- 数据类型  --------------------  */
/*
interface tabledata {
    cluster : string,
    markers : string,
    celltype: string,
    basis   : string
}
*/
/*
interface Message {
    id     : number;
    content: string;
    avatar : string; // URL
    side   : 'left' | 'right';
    time   : string; // HH:MM
  }
*/
interface Message{
  role   :string;                 // 角色
  content:string;                 // 信息
}
/* ----------------------- 变量 ---------------------- */
const tissue         = ref("")
const markergenes    = ref("")
const example        = "IGHM,IGHD,CD79A,IL4R,MS4A1,CXCR4,BTG1,TCL1A,CD79B,YBX3\nGZMH,CD4,FGFBP2,ITGB1,GZMA,CST7,GNLY,B2M,IL32,NKG7\nTCF7,CD4,CCR7,IL7R,FHIT,LEF1,MAL,NOSIP,LDHB,PIK3IP1\nIL7R,TMSB10,CD4,ITGB1,LTB,TRAC,AQP3,LDHB,IL32,MAL\nIL7R,CCL5,FYB1,GZMK,IL32,GZMA,KLRB1,TRAC,LTB,AQP3"
const uploadnum      = ref(0)
const uploadurl      = "http://aicelltype.jinlab.online/upload"
const tableData      = ref([])
const loading        = ref(false)
const tabshow        = ref(false)
const chatroom       = ref(false)
const messageData    = ref<Record<string,Array<Message>>>({})    // 所有对话记录
const msg            = ref<Array<Message>>([])                   // 窗口消息
const selectindex    = ref(0)
const prompt         = ref({
                          "markers" : "" ,
                          "celltype": "" ,
                          "tissue"  : "" 
                        })
const newMessage     = ref('');                                  // 窗口输入的消息
// 上传文件如果不用额外参数的话其实也可以把样本组织类型作为文件名上传
const info           = ref({
                            "tissue"     : "",
                            "temperature": 0.1
                          })
const chatDIV        = ref(null)
watch(()=>tissue.value,(newValue)=>{info.value.tissue = newValue})
/* ----------------- 文件上传前的操作 ----------------- */
const beforeupload: UploadProps['beforeUpload'] = (UploadRawFile)=>{
  // 文件大小校验
  if(UploadRawFile.size > 500 * 1024){
    alert(info.value.tissue)
    ElMessage.error(`file ${UploadRawFile.name} exceeds the maximum size of 100kb`)
    return false
  }
}

/* ----------------- 文件上传成功后的操作 ----------------- */
const onsuccess: UploadProps['onSuccess'] = (response, uploadFile, uploadFiles)=>{
  // 提示上传成功并且展示表格
  tableData.value = response
  tabshow.value   = true
}


/* ----------------- 文件上传失败后的操作 ----------------- */
const onerror: UploadProps['onError'] = (err, uploadFile, UploadFiles)=>{
  ElMessage.error(`file ${uploadFile.name} uoload failed, error message: ${err.name},${err.message}`)
}


const onremove: UploadProps['onRemove'] = (uploadFile, uploadFiles)=>{
  uploadnum.value = uploadFiles.length
}

const onchange: UploadProps['onChange'] = (uploadFile, uploadFiles)=>{
  uploadnum.value = uploadFiles.length
}
/* ----------------------- 提交注释 ----------------------- */
const uploadRef = ref<UploadInstance>()
function Annotation(){
  if(tissue.value == ""){
    ElNotification({
      title  : 'Error',
      message: 'Please enter the name of the tissue from which the cells are derived',
      type   : 'error',
    })
    return
  }
  if(uploadnum.value == 0 && markergenes.value == ""){
    ElMessageBox.confirm(
      "No markers gene was filled and no files were uploaded",
      "Error",
      {
        showCancelButton: false,
        confirmButtonText: 'OK',
        type: 'error',
      }
    )
    return
  }
  if(markergenes.value != ""){
    axios.post('/api_v2',
        {
        tissue      : tissue.value,
        markergenes : markergenes.value,
        temperature : 0.1

        }).then(function(response){
          tableData.value = response.data
          tabshow.value   = true
        }).catch(function(error){
          console.log(error)
        })
    return
  }
  if(uploadnum.value != 0){
    uploadRef.value!.submit()
  }
}

/* ----------------- 以选中的行继续循环提问 ----------------- */
function Connect_AI(idx){
  if(selectindex.value != idx){
    selectindex.value = idx
    newMessage.value  = ""
  }
  if(`${idx}` in messageData.value){
    msg.value = messageData.value[`${idx}`]
  }else{
    msg.value = []
  }
  prompt.value   = {
                    "celltype" : tableData.value[idx]['celltype'],
                    "markers"  : tableData.value[idx]['markers'],
                    "tissue"   : tissue.value
                  }
  chatroom.value = true
}
/* ----------------- 拼接字符串成tsv格式，blob ----------------- */


/* ------------------------------------------------------------ */
function sendMessage() {
  if(!newMessage.value.trim()){
    return
  }
  msg.value.push({'role':'user', 'content':newMessage.value})
  newMessage.value = ""
  loading.value    = true
  axios.post('/ai',{
              "prompt":prompt.value,
              "info"  :msg.value
              }).then(function(response){
                loading.value = false
                msg.value.push(response.data)
                if(chatDIV.value){
                  nextTick(()=>{
                    chatDIV.value.scrollTop = chatDIV.value.scrollHeight
                  })
                }
              }).catch(function(error){
                ElMessageBox.confirm(
                      `${error}`,
                      "Error",
                      {
                        showCancelButton: false,
                        confirmButtonText: 'OK',
                        type: 'error',
                      }
                    )
                console.log(error)
                loading.value = false
              })
}

/* ------------------------------------------------------------ */
function ChatBeforeClose(done:()=>void){
  messageData.value[`${selectindex.value}`] = msg.value
  done()
}
/* ------------------------------------------------------------ */
function DownloadSample(){
  axios.get('/download',{
            responseType: 'blob'
        }).then(function(response){
          const disposition = response.headers['content-disposition']
          let filename = 'cluster_top10.csv'
          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
        }).catch(function(error){
          console.log(error)
        })
}
</script>

<style lang="less">
html,body,template{
  margin-top : 0px;
  margin-left: 0px;
  overflow-y: hidden;
}
#app {
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0,0,0,0;
}
/* ----------------------------------------------------- */
.container {
    display      : flex;          // 开启 Flexbox
    gap          : 0px;           // 两列之间的间隙
    margin-top   : 0px;
    margin-left  : 0px;
    height       : 100vh;
    overflow     : hidden;    
  }
/* ----------------------------------------------------- */
  .left  {
    width     : 400px;
    text-align: left;
    height    : 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding   : 10px;
    box-sizing: border-box;
  }
  .Side{
    margin-left : 20pt;
    margin-right: 10pt;
    margin-top  : 10pt;
  }
/* ----------------------------------------------------- */     
  .right { 
    flex      : 1;
    text-align: left;
    padding   : 10px;
    box-sizing: border-box;
  }
  .child{
    width     : 800pt;
    margin    : 0 auto;
    padding   : 10px;
    box-sizing: border-box;
    margin-top: 50pt;
  }
  /* ----------------------------------------------------- */ 
  // 聊天窗口
  .chat{
    height: 600pt;
  }
  .chat-msg.system {
    display        : flex;
    justify-content: flex-start;
    margin-top     : 10pt;
    margin-right   : 40%;
  }
  .chat-msg.user {
    display         : flex;
    justify-content : flex-end;
    margin-top      : 10pt;
    margin-left     : 40%;
    color:burlywood
  }
  // 消息框
  .chat-message{
    height    : 514pt;
    overflow-y: auto;
  }
  // 输入框
  .chat-input{
    display      : flex;
    gap          : 10pt;
    align-items  : center;
  }
  .chat-input-button{
    display        : flex;
    justify-content: center; 
    align-items    : center;
  }
/* ----------------------------------------------------- */
  /*
  @media (max-width: 600px) {
    .container { flex-direction: column; }
  }
    */
  /* ----------------------------------------------------- */
</style>
